import { Button, Checkbox, Divider, Grid, Group, InputBase, Pill, Text, TextInput, Title } from '@mantine/core'
import { useForm } from '@mantine/form';
import { useContext, useEffect, useMemo, useState } from 'react';
import { BaseResult, UpsertCampaignRequest, Customer, Campaign, Fund, MessageRecipientData } from '../../types';
import { CustomerSelectComponent } from '../../components/customer_select_component';
import { CustomerTagSelectComponent } from '../../components/customer_tag_select_component';
import { httpsCallable } from 'firebase/functions';
import { MessagesSent } from '../../components/send_sms_modal';
import { useFirestore, useFunctions } from '../../helpers/firebaseContext';
import { useNavigate, useParams } from 'react-router-dom';
import BasicCampaignForm from './basic_campaign_form';
import {
    doc, getDoc,

    // where
} from 'firebase/firestore';
import * as MicrosoftGraph from "@microsoft/microsoft-graph-types"

import { GlobalDataContext, MyUserDataContext } from '../../contexts';
import { CustomerSegmentSelectComponent } from '../../components/customer_segment_select_component';
import UserGroupsSearch from '../../components/user_groups_search';
import { RmsSegmentSelectComponent } from '../../components/rms_segment_select_component';

type RmRecipientRole = "rm" | "operations";

const CreateCampaign = () => {
    const appContext = useContext(MyUserDataContext);
    const [chosenCustomersList, setChosenCustomersList] = useState<Partial<Customer>[]>([])
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [SMSDocID,] = useState<string[]>();
    const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false);
    const [errMsg, setErrMsg] = useState<string>();
    const [campaign, setCampaign] = useState<UpsertCampaignRequest>();
    const [chosenFund, setChosenFund] = useState<Fund>();

    // const [funds, setFunds] = useState<FundAutoComplete[]>([]);
    const functions = useFunctions();
    const navigate = useNavigate();
    const db = useFirestore();

    const { campaignId } = useParams();

    const globalDataContext = useContext(GlobalDataContext);

    const funds = globalDataContext?.funds?.map((fundObj) => { return { ...fundObj, label: fundObj.name_en, value: fundObj.id } }) || []

    const form = useForm<
        UpsertCampaignRequest
    >({
        initialValues: {
            title: "",
            rmRecipients: [],
            rmRecipientRoles: ["rm", "operations"],
            segmentsRecipients: [],
            customerRecipients: [],
            employeeRecipients: [],
            tagsRecipients: [],
            smsMessage: "",
            type: [],
            updateLink: {
                updateType: "broadcast",
            },

            messageVariables: {},
        },

    });


    useEffect(() => {
        form.setFieldValue("customerRecipients", chosenCustomersList?.map((customer) => customer.id!))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chosenCustomersList])

    //get funds  and campaign data
    useEffect(() => {



        const getCampaign = async () => {
            let campaignRef = doc(db, "campaigns", campaignId!);

            const campaignDoc = await getDoc(campaignRef);



            if (campaignDoc.exists()) {
                const campaignData = campaignDoc.data() as Campaign;
                setCampaign({
                    ...campaignData,
                    updateLink: {
                        updateType: "broadcast",
                    },

                });
                if (campaignData?.customer_ids?.length) {

                    setChosenCustomersList(campaignData.customer_ids.map(((customerID) => {
                        return {
                            id: customerID,

                        }
                    })));
                }
                const fundTags = funds.filter((fundObj) => campaignData.tagsRecipients.includes(fundObj.id))

                if (fundTags?.length === 1)
                    setChosenFund(fundTags[0])
            }


        }
        if (campaignId) {

            getCampaign();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [campaignId]);



    useEffect(() => {


        form.setValues({
            ...campaign,
        })

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [campaign])


    const renderBasicCampaignForm = useMemo(() =>
        <>
            <BasicCampaignForm form={form} funds={chosenFund ? [{
                ...chosenFund,
                id: chosenFund.id,
                label: `${chosenFund.name_en} - ${chosenFund.name_ar}`,
                value: chosenFund.id,
            }] : funds?.map((fundObj) => {

                return {
                    ...fundObj,
                    id: fundObj.id,
                    label: `${fundObj.name_en} - ${fundObj.name_ar}`,
                    value: fundObj.id,
                }
            })} />

        </>
        , [form, funds, chosenFund])

    return (
        <Grid justify='center' bg={"white"} h="100%">
            <Grid.Col span={{ xs: 12 }}>


                <Title
                    ms={30}
                    mt={30}
                    mb={20}
                    order={4}
                    ta="left">{campaignId ? "Edit" : "Create"} Campaign</Title>
            </Grid.Col>
            {/* <LoadingOverlay visible={visible} loaderProps={{ children: 'Loading...' }} /> */}

            <Grid.Col span={{ lg: 8 }}>

                <form
                    onSubmit={form.onSubmit(async (values) => {
                        setErrMsg(undefined)
                        values.employeeRecipients = []
                        if (values.customerRecipients.length <= 0 && values.tagsRecipients.length <= 0 && values.segmentsRecipients.length <= 0) {
                            setErrMsg("either customers or tags/segments need to be added");
                            return;
                        }
                        if (values.rmRecipients.length > 0 && !values.rmRecipientRoles?.length) {
                            setErrMsg("at least one RM role must be selected");
                            return;
                        }
                        if (values.type.length <= 0) {
                            setErrMsg("atleast one type must be selected");
                            return;
                        }

                        if (values.employeeRecipientGroupIds?.length && appContext.microsoftClient) {
                            const groupMembers = await Promise.all(values.employeeRecipientGroupIds.map(async (groupId) => {
                                const result = await appContext.microsoftClient
                                    ?.api(`/groups/${groupId}/members`)
                                    .header("ConsistencyLevel", "eventual")
                                    .top(999)
                                    .get();
                                return (result?.value as MicrosoftGraph.User[]) || [];
                            }));
                            const recipientsMap = new Map<string, MessageRecipientData>();
                            groupMembers.flat().forEach((userObj) => {
                                if (!userObj.id) {
                                    return;
                                }
                                if (!userObj?.mobilePhone || !userObj?.mobilePhone?.length) {
                                    return;
                                }

                                const cleanedUpMobilePhoneArray = userObj.mobilePhone.split("+(965)  ");
                                const userMobile =
                                    cleanedUpMobilePhoneArray.length > 1
                                        ? cleanedUpMobilePhoneArray[1].trim()
                                        : "";
                                recipientsMap.set(userObj.id, {
                                    mobile: userMobile ?? "",
                                    id: userObj.id,
                                    email: userObj.mail ?? "",
                                    smsMessage: "",
                                    name_ar: userObj.displayName ?? "",
                                    name_en: userObj.displayName ?? "",
                                });
                            });
                            values.employeeRecipients = Array.from(recipientsMap.values());
                        }

                        setLoadingSubmit(true)
                        try {


                            if (campaignId) {

                                const EditCampaign = httpsCallable<UpsertCampaignRequest, BaseResult>(functions, "editCampaign");


                                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                const response = await EditCampaign({
                                    ...campaign,
                                    ...values
                                })
                            }
                            else {

                                const createCampaign = httpsCallable<UpsertCampaignRequest, BaseResult>(functions, "createCampaign");
                                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                const response = await createCampaign(values)
                            }
                            setLoadingSubmit(false);
                            navigate("/campaigns");
                            return;

                            // if (response?.data?.messageID) {

                            //     setSMSDocID([response?.data?.messageID]);
                            //     setLoadingSubmit(false);


                            // }
                            // if (response?.data?.messageIDsList) {
                            //     setSMSDocID(response?.data?.messageIDsList);
                            //     setLoadingSubmit(false);

                            // }


                        }
                        catch (e: any) {
                            if (e?.message) {
                                setErrMsg(e?.message)

                            }
                            else {
                                setErrMsg("an unexpcted error has occurred ")

                            }

                            setLoadingSubmit(false);

                        }

                    })}
                >
                    <Grid>

                        <Grid.Col span={{ xs: 12 }}>
                            <TextInput
                                label="Title"
                                required
                                // placeholder=''
                                // mt={10}
                                {...form.getInputProps('title')}
                                value={form.values.title}
                                error={form.errors.title}
                                onChange={(e) => {
                                    form.setFieldValue("title", e.target.value)
                                }}
                            />
                        </Grid.Col>

                        <Grid.Col span={{ lg: 4 }}>
                            <CustomerSelectComponent
                                textProps={{
                                    label: "Search Customers by (ID / Name / Tag)",
                                    required: false
                                }}

                                submitType="object"
                                handleSubmit={(customerUserObj) => {
                                    let customerUser = customerUserObj as Customer
                                    if (customerUser) {
                                        const foundCustomer = chosenCustomersList.find((chosenCustomer) => chosenCustomer.id === customerUser.id)
                                        if (!foundCustomer) {
                                            setChosenCustomersList([...chosenCustomersList, customerUser])
                                        }
                                    }
                                }}
                            />
                        </Grid.Col>
                        <Grid.Col span={{ lg: 8 }}>
                            <InputBase component="div"
                                multiline
                                // placeholder='Chosen Customers'
                                label="Chosen Customers"
                            >
                                <Pill.Group
                                // placeholder='Chosen Customers'
                                >{chosenCustomersList.map((chosenCustomer) => <Pill
                                    withRemoveButton
                                    onRemove={() => {
                                        const updatedCustomersList = chosenCustomersList.filter((customerUser) =>
                                            customerUser.id !== chosenCustomer.id
                                        )
                                        setChosenCustomersList(updatedCustomersList)
                                    }}
                                >
                                    {chosenCustomer?.name_en} -  {chosenCustomer?.id}
                                </Pill>)}
                                </Pill.Group>
                            </InputBase>
                        </Grid.Col>
                        <Divider my="md" w="100%" />

                        <Grid.Col span={{ xs: 12 }}>

                            <CustomerTagSelectComponent
                                textProps={{
                                    label: "Tags",
                                    required: false
                                }}
                                // fundsList={funds}
                                tagsList={form.values.tagsRecipients}

                                onChange={(value) => {
                                    form.setFieldValue("tagsRecipients", value)
                                }}
                            />
                        </Grid.Col>
                        <Divider my="md" w="100%" />
                        <Grid.Col span={{ xs: 12 }}>

                            <Grid.Col span={{ xs: 12 }}>
                                <UserGroupsSearch values={form.values.employeeRecipientGroupIds} label={"Employees"} onItemSubmit={(values: string[]) => form.setFieldValue("employeeRecipientGroupIds", values)} apiURl={"/groups/"} />
                            </Grid.Col>
                        </Grid.Col>
                        <Divider my="md" w="100%" />
                        <Grid.Col span={{ xs: 12 }}>

                            <CustomerSegmentSelectComponent
                                textProps={{
                                    label: "Segments",
                                    required: false
                                }}
                                // fundsList={funds}
                                segmentsList={form.values.segmentsRecipients}

                                onChange={(value) => {
                                    form.setFieldValue("segmentsRecipients", value)
                                }}
                            />
                        </Grid.Col>
                        <Divider my="md" w="100%" />
                        <Grid.Col span={{ xs: 12 }}>
                            {renderBasicCampaignForm}
                        </Grid.Col>
                        <Divider my="md" w="100%" />
                        <Grid.Col span={{ xs: 12 }}>
                            <Title order={6}>RM Recipients</Title>
                        </Grid.Col>
                        <Grid.Col span={{ md: 4 }}>
                            <Checkbox.Group
                                label="RM Role"
                                value={form.values.rmRecipientRoles || []}
                                onChange={(values) => {
                                    form.setFieldValue("rmRecipientRoles", values as RmRecipientRole[])
                                }}
                            >
                                <Group mt="xs">
                                    <Checkbox color="green" value="rm" label="RM" />
                                    <Checkbox color="green" value="operations" label="Operations" />
                                </Group>
                            </Checkbox.Group>
                        </Grid.Col>
                        <Grid.Col span={{ md: 8 }}>
                            <RmsSegmentSelectComponent
                                textProps={{
                                    label: "RM Segments",
                                    required: false
                                }}
                                segmentsList={form.values.rmRecipients}
                                onChange={(value) => {
                                    form.setFieldValue("rmRecipients", value)
                                }}
                            />
                        </Grid.Col>
                        <Grid.Col span={{ xs: 12 }} >
                            {
                                SMSDocID?.map((smsDoc) => <MessagesSent docID={smsDoc} />)
                            }
                        </Grid.Col>
                        <Grid.Col span={{ xs: 12 }} >
                            <Text c={"red"}>
                                {errMsg}
                            </Text>
                        </Grid.Col>

                        <Grid.Col span={{ xs: 3 }} >
                            <Button
                                loading={loadingSubmit}
                                color='green'
                                type='submit'
                                fullWidth

                            >
                                {campaignId ? "Edit" : "Create"}
                            </Button>
                        </Grid.Col>
                    </Grid>
                </form>
            </Grid.Col>

        </Grid >
    )
}

export default CreateCampaign
